export default __webpack_public_path__ + "static/media/twitterWhite.af5e88f6.svg";